import { ReactElement} from "react";
import subtract from "./subtract.svg";
import ReactMarkdown from "react-markdown";
import { requestExerciseLoadFile } from "../../api/lesson";
import "./index.css";

interface IProps {
  id: number;
  title?: string;
  content?: string;
  onClickNextEx: () => void;
}

export function LoadFileLesson(props: IProps): ReactElement {
  const onclkbtn = () => {
    requestExerciseLoadFile(props.id);
    props.onClickNextEx();
  }

  return (
    <>
      <div className="textConteiner">
        <div className="textConteiner-text">
          <h1>{props.title}</h1>
          <ReactMarkdown>{props.content}</ReactMarkdown>
          <div className="loadFileConteiner">
            <img src={subtract} alt="file icon"></img>
            {props.title}
          </div>
        </div>
      </div>
      <div className="lessonPageOnward-button" onClick={onclkbtn}>
        Отправить в чат
      </div>
    </>
  );
}
